export const X_AUTH_TOKEN = 'X_AUTH_TOKEN'
